import { useRef, useState } from 'react';
import { BLADES } from './SectionDecor';

const CLIP_COLORS = ['#65a30d', '#4d7c0f', '#84cc16', '#16a34a'];

const shortGrass = `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 40' preserveAspectRatio='none' width='600' height='40'><path d='${BLADES}' fill='%237cb342'/></svg>")`;

const MowedTrail = ({ width, fading }) => (
  <div
    aria-hidden="true"
    data-testid="hero-mowed-trail"
    className="absolute bottom-0 left-0 h-10 pointer-events-none z-[5] bg-white"
    style={{ width, opacity: fading ? 0 : 1, transition: fading ? 'opacity 4s ease-in 1.5s' : 'none' }}
  >
    <div
      className="absolute bottom-0 left-0 right-0 h-3"
      style={{ backgroundImage: shortGrass, backgroundRepeat: 'repeat-x', backgroundSize: '300px 100%', backgroundColor: 'transparent' }}
    />
    <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#7cb342]" />
  </div>
);

const Clipping = ({ c }) => (
  <span
    className="grass-clip"
    style={{ left: c.x, '--dx': `${c.dx}px`, '--dy': `${c.dy}px`, '--r': `${c.r}deg`, backgroundColor: c.color }}
  />
);

export const HeroMower = () => {
  const ref = useRef(null);
  const [driving, setDriving] = useState(false);
  const [x, setX] = useState(0);
  const [clips, setClips] = useState([]);
  const [trail, setTrail] = useState({ width: 0, fading: false });

  const drive = () => {
    if (driving) return;
    const el = ref.current;
    const W = el.parentElement.offsetWidth;
    const w = el.offsetWidth;
    const duration = Math.max(3500, W * 2.4);
    let t0 = null;
    let lastClip = 0;
    let id = 0;
    setDriving(true);
    setTrail({ width: 0, fading: false });
    const step = (ts) => {
      if (t0 === null) t0 = ts;
      const p = Math.min((ts - t0) / duration, 1);
      const cur = -w + p * (W + w * 2);
      setX(cur);
      setTrail({ width: Math.max(0, cur + w * 0.55), fading: false });
      if (ts - lastClip > 40) {
        lastClip = ts;
        const n = id++;
        setClips((prev) => [...prev.slice(-30), {
          id: n,
          x: cur + w * 0.2,
          dx: -(15 + Math.random() * 45),
          dy: -(12 + Math.random() * 30),
          r: Math.random() * 360,
          color: CLIP_COLORS[n % CLIP_COLORS.length],
        }]);
      }
      if (p < 1) requestAnimationFrame(step);
      else {
        setDriving(false);
        setTimeout(() => setClips([]), 1000);
        setTrail((t) => ({ ...t, fading: true }));
        setTimeout(() => setTrail((t) => (t.fading ? { width: 0, fading: false } : t)), 6000);
      }
    };
    requestAnimationFrame(step);
  };

  return (
    <>
      {trail.width > 0 && <MowedTrail width={trail.width} fading={trail.fading} />}
      {clips.map((c) => <Clipping key={c.id} c={c} />)}
      <button
        ref={ref}
        type="button"
        onClick={drive}
        data-testid="hero-mower-btn"
        aria-label="Drive the mower"
        title="Click me!"
        className={`absolute bottom-1 z-20 w-20 md:w-28 lg:w-32 cursor-pointer focus:outline-none ${driving ? '' : 'right-[8%] md:right-[14%] hover:-translate-y-0.5 transition-transform'}`}
        style={driving ? { left: x } : undefined}
      >
        <img
          src="/images/hero-mower.png"
          alt=""
          draggable="false"
          data-testid="hero-mower"
          className="hero-mower w-full select-none pointer-events-none"
          style={driving ? undefined : { scale: '-1 1' }}
        />
      </button>
    </>
  );
};
